"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeviceId = exports.getDeviceType = void 0;
const getDeviceType_1 = __importDefault(require("./getDeviceType"));
exports.getDeviceType = getDeviceType_1.default;
const getDeviceId_1 = __importDefault(require("./getDeviceId"));
exports.getDeviceId = getDeviceId_1.default;
